"use strict";
exports.__esModule = true;
var ReactPlaceholder_1 = require("./ReactPlaceholder");
exports["default"] = ReactPlaceholder_1["default"];



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-placeholder/lib/index.js
// module id = 10
// module chunks = 12